export function extractRefCode(startParam: string | undefined): string | null {
	if (!startParam) {
		return null
	}

	if (startParam.startsWith("tg_ref_code=")) {
		return startParam.substring("tg_ref_code=".length)
	}

	return null
}
